import styled from 'styled-components/macro';
import * as colors from '../colorConstants';

export const DownloadButtonLabel = styled.span`
  margin: 0 4px;
`;

export const DownloadButton = styled.button`
  outline: none;
  height: 26px;
  border-radius: 3px;
  border: 1px solid ${colors.lightGray1};
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 7px;
  margin-top: 5px;
  cursor: pointer;
  background-color: ${colors.white};
  animation-name: fadeIn;
  animation-duration: 0.8s;
  color: ${colors.black4};
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 100%;
    }
  }

  &:hover {
    border: 1px solid ${colors.blue1};
    color: ${colors.blue1};
    img {
      content: url(${(props) => props.hoverIcon});
    }
  }
`;
